import type {
  AccrualsMapperT,
  LoadAccrualsResponseT,
  AccrualRecordDtoT,
} from "../types/accruals.types";
import type {
  AccrualRowT,
  AccrualRowWithIndexT,
} from "../../domain/types/accrual.types";
import type { AccrualLoadResultT } from "../../domain/entities/accrual.entity";

const hasValue = (value: string | number): boolean =>
  value !== "" && value !== null && value !== undefined;

const buildRecordDto = (
  row: AccrualRowT,
  rowNumber: number,
): AccrualRecordDtoT => {
  const record: AccrualRecordDtoT = {
    row_number: rowNumber,
    collaborator_id: row.collaboratorId,
    description: String(row.description).trim(),
    is_initial_balance: row.isInitialBalance,
    vacation_days: `${row.vacationDaysAccrued}`,
    prima_percentage: `${row.vacationPremiumPct}`,
  };

  if (row.admissionDate) {
    record.registration_date = row.admissionDate;
  }

  if (hasValue(row.vacationDaysTaken)) {
    record.vacation_taken = `${row.vacationDaysTaken}`;
  }

  if (hasValue(row.vacationPremiumDays)) {
    record.prima_days = `${row.vacationPremiumDays}`;
  }

  return record;
};

const mapResponseToDomain = (
  rawData: LoadAccrualsResponseT,
): AccrualLoadResultT => ({
  errors: (rawData?.data?.errors ?? []).map((e) => ({
    collaboratorId: e.collaborator_id,
    error: e.error,
    rowNumber: e.row_number,
  })),
  processed: rawData?.data?.processed ?? 0,
  failed: rawData?.data?.failed ?? 0,
  totalRows: rawData?.data?.total_rows ?? 0,
  message: rawData?.data?.message ?? "",
});

export const accrualsMapper: AccrualsMapperT = {
  toRequestDto: (rows: AccrualRowWithIndexT[]) => ({
    records: rows.map((row) => buildRecordDto(row, row.rowNumber)),
  }),
  toDomain: mapResponseToDomain,
  toCreateRequestDto: (rows: AccrualRowT[]) => ({
    records: rows.map((row, index) => buildRecordDto(row, index)),
  }),
  createDtoToDomain: mapResponseToDomain,
};
